/**
 * Drag-scroll utility — apply to any horizontally scrollable container
 * Usage: initDragScroll(element)
 */
function initDragScroll(el) {
  if (!el) return;
  let isDown = false, startX, scrollLeft;

  el.addEventListener('mousedown', (e) => {
    isDown = true;
    el.classList.add('is-dragging');
    startX = e.pageX - el.offsetLeft;
    scrollLeft = el.scrollLeft;
    e.preventDefault();
  });
  el.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const walk = (x - startX) * 1.5;
    el.scrollLeft = scrollLeft - walk;
  });
  el.addEventListener('mouseup', () => { isDown = false; el.classList.remove('is-dragging'); });
  el.addEventListener('mouseleave', () => { isDown = false; el.classList.remove('is-dragging'); });
}
